export const WS_ENDPOINTS = {
  INQUIRY_STATUSES: "inquiry-statuses",
  EXTERNAL_PERMISSIONS: "external-permissions"
} as const;
